<template>
  <div :class="bemBlock">
    <h2 :class="bemElement('title')">
      {{ $msg('product.complement.selector.title', 'customizer') }}
    </h2>
    <div :class="bemElement('filters')">
      <button
        v-for="(set, index) in complementProducts"
        :key="`${set.productName}-${index}`"
        :class="
          bemElement('filter-button', {
            selected: set.productName === selectedFilter,
          })
        "
        @click="selectFilter($event, set.productName)"
      >
        <img
          v-if="!!getColorImage(set)"
          :set="image = getColorImage(set)"
          :alt="image.alt"
          :class="[
            bemElement('swatch-img'),
            {
              loading: loadingImage,
            },
          ]"
          :src="image.url"
          @error="handleImageError"
          @load="loadingImage = false"
        />
        {{ set.productName }}
      </button>
    </div>
    <div ref="productsContainer" :class="bemElement('products')">
      <div
        v-for="(set, index) in complementProducts"
        v-show="set.productName === selectedFilter"
        :key="index"
        :class="bemElement('product-set')"
        :style="calculateGridColumns(set.individualProducts)"
      >
        <TheProductCustomizerComplement
          v-for="(product, i) in set.individualProducts"
          :key="`${product.id}-${i}`"
          :product="product"
          :reset="reset"
        />
      </div>
    </div>
    <BaseProgressBar :container="$refs.productsContainer" />
    <p :class="bemElement('message')">
      {{
        customizerId === 'designer'
          ? $msg('designer.complement.selector.info', 'customizer')
          : $msg('customizer.complement.selector.info', 'customizer')
      }}
    </p>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import bemClassesMixin from '../../mixins/bemClassesMixin';
import BaseProgressBar from '../BaseProgressBar.vue';
import TheProductCustomizerComplement from './TheProductCustomizerComplement.vue';
import { getters } from '../../store';

const GRID_ROWS = 4;

export default {
  name: 'TheProductCustomizerComplementSelector',

  components: {
    BaseProgressBar,
    TheProductCustomizerComplement,
  },

  mixins: [bemClassesMixin],

  props: {
    reset: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  data() {
    return {
      selectedFilter: null,
      loadingImage: true,
    };
  },

  computed: {
    ...mapGetters({
      complementProducts: getters.productCustomizer.complementProducts,
      customizerId: getters.productCustomizer.customizerId,
    }),
  },

  watch: {
    reset() {
      if (this.reset) {
        this.selectedFilter = null;
        this.selectInitialFilter();
      }
    },
  },

  mounted() {
    this.selectInitialFilter();
  },

  methods: {
    calculateGridColumns(array) {
      return `--grid-columns: ${Math.ceil(array.length / GRID_ROWS)}`;
    },
    getColorImage(set) {
      return set.bylImages?.['pdp-small']?.[0];
    },
    handleImageError(e) {
      const noImagePlaceholderColor = '#e0e0e0';
      const noImagePlaceholder = `<svg xmlns='http://www.w3.org/2000/svg' width='8' height='8'><rect width='8' height='8' fill='${noImagePlaceholderColor}'/></svg>`;
      const noImagePlaceholderUrl = `data:image/svg+xml,${encodeURIComponent(
        noImagePlaceholder
      )}`;
      const noImage = {
        alt: '',
        title: '',
        url: noImagePlaceholderUrl,
      };
      const img = e.target;
      img.src = noImage.url;
    },
    selectFilter(event, filter) {
      this.selectedFilter = filter;
    },
    selectInitialFilter() {
      this.complementProducts.forEach((set) => {
        if (
          !this.selectedFilter &&
          set.individualProducts.some((product) => product.available)
        ) {
          this.selectedFilter = set.productName;
        }
      });
      if (!this.selectedFilter) {
        this.selectedFilter = this.complementProducts?.[0]?.productName;
      }
    },
  },
};
</script>
